import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Card, Grid, Typography, Tooltip } from '@material-ui/core';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import axios from 'axios';

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    width: 293,
    height: 160
  },
  container: {
    marginTop: theme.spacing(1),
    height: 45
  },
  content: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    height: 65
  },
  titleSpace: {
    alignContent: 'center',
    marginLeft: theme.spacing(1)
  },
  title: {
    fontWeight: 700
  },
  scoreSpace: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    border: '1px dashed #2979ff',
    justifyContent: 'center',
    height: 30,
    width: 60
  },
  score: {
    cursor: 'pointer',
    color: '#2979ff'
  },
  button: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    alignContent: 'center'
  },
  list: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2)
  }
}));

const AssociationAH = props => {
  const classes = useStyles();
  const {
    recommendation,
    AHCallback,
    selectedCard,
    setSelectedCard,
    handleOpen,
    setDetails,
    //setVisQuery,
    setOtherCard,
    userID,
    ...rest
  } = props;

  const handleVisualization = async (idx, item) => {
    setSelectedCard(idx);
    AHCallback(item);
    setOtherCard();
    let user = JSON.parse(localStorage.getItem('User'));
    let bloomQuery = `MATCH p=shortestPath((ah:AccountHolder{accountHolderID:${userID}})-[:MAKES_PAYMENTS_TO*]-(cu:AccountHolder{accountHolderID:$customerID})) RETURN p`;
    await axios
      .post(process.env.REACT_APP_DASHBOARD_URI, {
        query: `
      mutation StoreBloomPerspective($bloomQuery:String!,$email:String!){
        storeBloomPerspective(bloomQuery:$bloomQuery,email:$email)
      }
      `,
        variables: { bloomQuery: bloomQuery, email: user.email }
      })
      .then(data => {
        console.log(data);
      })
      .catch(err => {
        console.log(err);
      });
    //setVisQuery(bloomQuery);
  };

  const handlePopup = (details, idx) => {
    setDetails(details);
    setSelectedCard(idx);
    handleOpen(true);
  };

  return recommendation.data.recommendations.map(
    ({ item, score, details }, idx) => (
      <Card
        key={item.accountHolderID}
        className={classes.root}
        style={{
          border: idx === selectedCard ? '2px solid #2979ff' : '',
          elevation: idx === selectedCard ? 1 : 0
        }}
        {...rest}>
        <Grid container item xs={12} className={classes.container}>
          <Grid item xs={11} className={classes.titleSpace}>
            <Tooltip title={item.accountName} enterDelay={1000}>
              <Typography
                className={classes.title}
                align="center"
                gutterBottom={false}
                variant="h5"
                color="secondary">
                {item.accountName.length > 40
                  ? item.accountName.substring(0, 40) + '...'
                  : item.accountName}
              </Typography>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid container item xs={12}>
          <Grid item xs={6} className={classes.content}>
            <Typography variant="h6">
              Account-ID: {item.accountHolderID}
            </Typography>
            <div>
              {item.gender ? (
                <Typography variant="h6">Gender: {item.gender}</Typography>
              ) : null}
            </div>
          </Grid>
          <Grid item xs={3} className={classes.button}>
            <Button
              variant="contained"
              size="large"
              color="secondary"
              style={{ left: '30%' }}
              onClick={() => {
                handleVisualization(idx, item, details);
              }}>
              <BubbleChartIcon
                style={{ fontSize: '140%' }}
                component="svg"
                variant="contained"
              />
            </Button>
          </Grid>
          <Grid item xs={6} className={classes.scoreSpace}>
            <Typography
              className={classes.score}
              align="center"
              variant="h6"
              onClick={() => {
                handlePopup(details, idx);
              }}>
              SCORE: {score.toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
      </Card>
    )
  );
};

AssociationAH.propTypes = {
  className: PropTypes.string
};

export default AssociationAH;
